import { render, staticRenderFns } from "./staffLogs.vue?vue&type=template&id=22327cc2&scoped=true"
import script from "./staffLogs.js?vue&type=script&lang=js&external"
export * from "./staffLogs.js?vue&type=script&lang=js&external"
import style0 from "./staffLogs.vue?vue&type=style&index=0&id=22327cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22327cc2",
  null
  
)

export default component.exports